import templateUrl from "./user-send-notification.html";

export const userSendNotificationComponent = {
  bindings: {
    details: "<",
  },
  templateUrl,
  controller: class UserSendNotificationComponent {
    constructor(toastr, $window, UserService, Constants) {
      "ngInject";
      this.$window = $window;
      this._toastr = toastr;
      this.Constants = Constants;
      this.userService = UserService;
      this.plainDescription = "";
    }
    $onInit() {
      this.disableButtons = false;
    }
    goBack() {
      this.$window.history.back();
    }
    onSubmit() {
      if (this.plainDescription.trim()) {
        this.disableButtons = true;
        this.userService
          .sendUserEmailNotificationById(this.details)
          .then((res) => {
            this._toastr.success("Email notification sent successfully");
            this.goBack();
          })
          .catch((err) => {
            this.disableButtons = false;
            this._toastr.error(err.data ? err.data[0].message : err.message);
            this.goBack();
          });
      }
    }

    onCancel() {
      this.goBack();
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/components/user/user-send-notification/user-send-notification.component.js